import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref, reactive, computed, onBeforeMount, nextTick, onMounted,shallowRef, onBeforeUnmount, watch} from 'vue'
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import Api from '@/http/modules/index'
import {ElLoading} from "element-plus";

export default /*#__PURE__*/_defineComponent({
  props: {
    description:{
        default:''
    },
    isCreat:{
        default:true
    },
    height:{ 
        default:500
    },
    status:{
        default:'Back',
        type:String
    }
},
  emits: ["setData"],
  setup(__props, { emit }) {

const props = __props

let {
    // 'POST/order/delivery/upload_file': deliveryUpload_fileApi,
    'POST/upload': uploadpload_fileApi,
    'GET/upload/preview': getFileApi,

}=Api


const description=ref(props.description)

const editorRef = shallowRef();

const toolbarConfig = {
    toolbarKeys: ["fontSize","bold","italic","underline","color","uploadImage",'uploadAttachment'],
};
const uploading=ref(false)
const editorConfig = { 
    placeholder: "请输入内容..." , 
    hoverbarKeys: {
        attachment: {
            menuKeys: ['downloadAttachment'], // “下载附件”菜单
        },
    },
    MENU_CONF: {

		uploadImage: {
            async customUpload(file: any, insertFn: any) {  // TS 语法   
                let formData = new FormData();
                formData.append("file", file);
                uploading.value=true
                uploadpload_fileApi(formData).then(({fileId,filename,url}:any) => {   
                    uploading.value=false  
                    insertFn(url,fileId) 
               }).catch(()=>{
                    uploading.value=false
                })              
            }
        },
        uploadAttachment: {
            customUpload(file: File, insertFn: Function) {
                uploading.value=true
                let formData = new FormData();
                formData.append("file", file);
                uploadpload_fileApi(formData).then(({fileId,filename,url}:any) => {  
                        uploading.value=false
                        insertFn(filename,url)
                }).catch(()=>{
                    uploading.value=false
                })
            }
                
        }


	},
};

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
})
const handleCreated = (editor:any) => {
  editorRef.value = editor; // 记录 editor 实例，重要！
  editorRef.value.disable()
  if(props.status=="Back"||props.status=="New"){
      editorRef.value.enable()
  }
}
watch(description, (curr, old) => {
  emit('setData',description.value)
})
watch(()=>props.description, (curr, old) => {
    if(!curr){
        description.value=""
    }
})
onMounted(()=>{
    
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'editor-content':_unref(props).isCreat,'editor-creat-height':_unref(props).isCreat,'editor-modify-height':!_unref(props).isCreat}),
    style: {"border":"1px solid #ccc"}
  }, [
    _createVNode(_unref(Toolbar), {
      style: {"border-bottom":"1px solid #ccc"},
      editor: _unref(editorRef),
      defaultConfig: toolbarConfig
    }, null, 8, ["editor"]),
    _withDirectives(_createVNode(_unref(Editor), {
      "element-loading-text": '附件上传中...',
      style: _normalizeStyle({minHeight: _unref(props).height+'px'}),
      modelValue: description.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((description).value = $event)),
      defaultConfig: editorConfig,
      onOnCreated: handleCreated
    }, null, 8, ["element-loading-text", "style", "modelValue"]), [
      [_directive_loading, uploading.value]
    ])
  ], 2))
}
}

})